import { Logo } from "@/components/shared/Logo";
import { LogoWhite } from "@/components/shared/LogoWhite";
import { Toaster } from "@/components/ui/sonner";

// Copper accent sourced from --sidebar-primary in index.css.
// Inlined here to name the intent ("copper") at the call site rather than
// leaning on a misleadingly-named sidebar token.
const COPPER = "oklch(0.6756 0.1849 42.89)";

// Mount reveal for the brand panel's editorial block. Children apply incremental
// `delay-[Nms]` utilities on top of this base to create a 40ms stagger.
const REVEAL =
    "animate-in fade-in-0 slide-in-from-bottom-1 duration-500 motion-reduce:animate-none";

const YEAR = new Date().getFullYear();

interface IProps {
    children: React.ReactNode;
}

export const AuthScreenContainer = ({ children }: IProps) => {
    return (
        <>
            <div className="flex h-dvh">
                {/* Brand panel; inert for a11y, editorial left-aligned composition */}
                <aside
                    aria-hidden="true"
                    className="bg-primary relative hidden basis-2/5 flex-col overflow-hidden p-10 lg:flex xl:p-14"
                    style={{ "--copper": COPPER } as React.CSSProperties}
                >
                    {/* Logo at top edge */}
                    <div className={REVEAL}>
                        <LogoWhite style={{ width: "168px" }} />
                    </div>

                    {/* Tagline block, optically centered and left-aligned.
                        Children stagger in at 40ms intervals for a single
                        mount reveal. */}
                    <div className="mt-auto mb-auto flex flex-col">
                        <h2
                            className={`${REVEAL} text-4xl leading-[1.02] font-semibold tracking-[-0.04em] text-white delay-[40ms] xl:text-5xl`}
                        >
                            Coverage analysis
                            <br />
                            your clients deserve.
                            <br />
                            <span style={{ color: "var(--copper)" }}>
                                In minutes.
                            </span>
                        </h2>
                        <p
                            className={`${REVEAL} mt-10 text-[11px] font-medium tracking-[0.22em] text-white/55 uppercase delay-[80ms]`}
                        >
                            Purpose-built for policy and contract review.
                        </p>
                    </div>

                    {/* Footer signature */}
                    <p
                        className={`${REVEAL} text-[11px] text-white/45 delay-[120ms]`}
                    >
                        © {YEAR} ContractScope Inc.
                    </p>
                </aside>

                {/* Form panel */}
                <div className="bg-background flex flex-1 flex-col items-center justify-center overflow-y-auto px-5 py-10 lg:basis-3/5 lg:px-10">
                    <div className="mb-8 lg:hidden">
                        <Logo style={{ width: "133px" }} />
                    </div>
                    <div className="w-full max-w-sm">{children}</div>
                </div>
            </div>
            <Toaster />
        </>
    );
};
